module.exports = __webpack_public_path__ + "assets/img/sweep-footer.ef66359c.png";